<script>
export default {
  props: {
    value: {
      type: Number
    },
    content: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  data: vm => ({
    status: {
      [vm.$enums.validationStatus.success]: {
        color: 'success',
        icon: 'mdi-check',
        content: vm.$t('component.documentValidation.documentValidationStatusFilter.success'),
        emitClickEvent: false
      },
      [vm.$enums.validationStatus.pending]: {
        color: 'yellow',
        icon: 'mdi-timer-sand',
        content: vm.$t('component.documentValidation.documentValidationStatusFilter.pending'),
        emitClickEvent: false
      },
      [vm.$enums.validationStatus.error]: {
        color: 'error',
        icon: 'mdi-alert',
        content: vm.$t('component.documentValidation.documentValidationStatusFilter.error'),
        emitClickEvent: true
      },
      [vm.$enums.validationStatus.userActionRequired]: {
        color: 'primary',
        icon: 'mdi-pencil-outline',
        content: vm.$t('component.documentValidation.documentValidationStatusFilter.user.action.required'),
        emitClickEvent: true
      }
    }
  })
}
</script>
<template>
  <v-tooltip content-class="dark_tip" top>
    <template #activator="{ on }">
      <v-list-item-content class="upload_status d-inline pa-2">
        <v-icon
          :id="`upload_validation_upload_status_${item.documentId}`"
          :color="status[value].color"
          :class="{ 'click-disabled': !status[value].emitClickEvent }"
          v-on="on"
          @click="status[value].emitClickEvent ? $emit('click') : () => {}">
          {{ status[value].icon }}</v-icon>
      </v-list-item-content>
    </template>
    <span>{{ status[value].content }}</span>
  </v-tooltip>
</template>
<style lang="scss" scoped>
.click-disabled {
  text-decoration: none !important;
  cursor: unset !important;
}
</style>
